import { AppThunk } from "@Store/index";
import fetchPlusPageCategoriesData from "./fetchCategoriesPageData";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AmberPlusCategoriesPageData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  error: string | null;
  data: {
    fieldData: any;
    id: any;
  };
}
export const initialState: AmberPlusCategoriesPageData = {
  readyStatus: "invalid",
  error: null,
  data: {
    fieldData: [],
    id: [],
  },
};

const amberPlusCategoriesPageData = createSlice({
  name: "amberPlusCategoriesPageData",
  initialState,
  reducers: {
    getPlusCategoryPageSuccess: (
      state: AmberPlusCategoriesPageData,
      { payload }: PayloadAction<any>,
    ) => {
      state.readyStatus = "success";
      state.data.fieldData = payload.data.fieldData;
      state.data.id = payload.data.id;
    },
  },
});

export const fetchPlusCategoriesDataIfNeeded =
  (props: any): AppThunk =>
  (dispatch, getState: any) => {
    const category_name = __CLIENT__ ? props?.match?.params?.id : props?.params?.id;
    let user_auth_token = "";
    if (__CLIENT__) {
      if (getState().router.action === "PUSH" && __CLIENT__) {
        window.scrollTo(0, 0);
      }
      return null;
      // eslint-disable-next-line no-else-return
    } else {
      user_auth_token = props?.req?.cookies?.user_auth_token;
    }

    const href = (__CLIENT__ ? window.location.href : props.req?.url) || null;
    return dispatch(
      fetchPlusPageCategoriesData({ url: href, token: user_auth_token, category: category_name }),
    );
  };

export default amberPlusCategoriesPageData.reducer;
export const { getPlusCategoryPageSuccess } = amberPlusCategoriesPageData.actions;
